import loadable from '@loadable/component'

export const KeyPoint = loadable(() => import('./KeyPoint'))
export const KeyPoints = loadable(() => import('./KeyPoints'))
export type { KeyPointProps, KeyPointRenderLinkProps } from './KeyPoint'
export type { KeyPointsProps } from './KeyPoints'
